export default "__VITE_ASSET__a598e063__"